"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var React = require("react");
var InputForm;
(function (InputForm_1) {
    var VALIDATE_TYPE;
    (function (VALIDATE_TYPE) {
        VALIDATE_TYPE[VALIDATE_TYPE["EXIST"] = 0] = "EXIST";
        VALIDATE_TYPE[VALIDATE_TYPE["SAME"] = 1] = "SAME";
    })(VALIDATE_TYPE = InputForm_1.VALIDATE_TYPE || (InputForm_1.VALIDATE_TYPE = {}));
    var ERROR_MESSAGE_TYPE;
    (function (ERROR_MESSAGE_TYPE) {
        ERROR_MESSAGE_TYPE[ERROR_MESSAGE_TYPE["VALIDATE"] = 0] = "VALIDATE";
        ERROR_MESSAGE_TYPE[ERROR_MESSAGE_TYPE["CLIENT"] = 1] = "CLIENT";
        ERROR_MESSAGE_TYPE[ERROR_MESSAGE_TYPE["SERVER"] = 2] = "SERVER";
    })(ERROR_MESSAGE_TYPE = InputForm_1.ERROR_MESSAGE_TYPE || (InputForm_1.ERROR_MESSAGE_TYPE = {}));
    /**
     * 入力項目のエラーメッセージコンポーネント(Stateless Functional Component)
     * text: エラーメッセージ
     */
    var InputError = function (props) {
        return React.createElement("div", { className: "help-block" }, props.text);
    };
    /**
     * 入力項目の説明委コンポーネント(Stateless Functional Component)
     * text: 説明文
     */
    var InputDescription = function (props) {
        return (React.createElement("div", null, props.text.split('<br>').map(function (line, i) {
            return (React.createElement("p", { key: 'index' + i, className: "form-input-msg" }, line));
        })));
    };
    /*
    * 汎用的なエラーメッセージコンポーネント(Stateless Functional Component)
    *  エラーメッセージ表示領域
    */
    var ErrorMessage = function (props) {
        return (React.createElement("div", { className: "form-error-box" }, props.text.split('<br>').map(function (line, i) {
            return React.createElement("p", { key: 'index' + i, className: "form-error" }, line);
        })));
    };
    /*
    * 汎用的な説明コンポーネント(Stateless Functional Component)
    *  text: ボタンの上に表示するボタンクリック時の挙動の説明等
    *    text内に<br>が含まれる場合は表示上も改行される
    */
    var Description = function (props) {
        return (React.createElement("div", { className: "form-description-box" }, props.text.split('<br>').map(function (line, i) {
            return React.createElement("p", { key: 'index' + i, className: "form-description" }, line);
        })));
    };
    /*
    * 汎用的なフォームコンポーネント利用時に良く表示するロゴ
    */
    InputForm_1.EkispertLogo = function () {
        return (React.createElement("div", { className: "login-logo" },
            React.createElement("a", { href: "login.html" },
                React.createElement("img", { src: "img/login/ekispert_logo.png", alt: "駅すぱあとWebサービスロゴ" }),
                React.createElement("br", null),
                React.createElement("span", { className: "sub-title" }, "- User Console -"))));
    };
    /*
    * 汎用的な入力ボックスコンポーネント
    *  label: labelタグのtextの値
    *  name: inputタグのname属性の値
    *  vakue: inputタグのbalue属性の値
    *  type: inputタグのtype属性の値
    *  placeholder: inputタグのplaceholder属性の値
    *  icon: テキストボックスの右端に入れるアイコン
    *    Bootstrap Glyphiconの場合　例）'glyphicon glyphicon-envelope'
    *    Font Awsomeの場合　例）'fa fa-key'
    *    Ioniconsの場合　例）'icon ion-home'
    *  description: テキストボックスの下に入れる説明
    *  setValue: 入力ボックスの値変更時に呼ばれる関数
    */
    var InputText = (function (_super) {
        __extends(InputText, _super);
        function InputText() {
            var _this = _super.call(this) || this;
            _this.handleChange = _this.handleChange.bind(_this);
            return _this;
        }
        InputText.prototype.handleChange = function (event) {
            if (this.props.setValue) {
                this.props.setValue(event.target.value);
            }
        };
        InputText.prototype.render = function () {
            var errorMessage = this.props.errorMessage;
            var description = this.props.description;
            var spanClassNameValue = this.props.icon + ' form-control-feedback';
            var groupClassName = 'form-group has-feedback' + (errorMessage ? ' has-error' : '');
            var errorMessageElement = null;
            var descriptionElement = null;
            if (errorMessage) {
                errorMessageElement = React.createElement(InputError, { text: errorMessage.text });
            }
            if (description) {
                descriptionElement = React.createElement(InputDescription, { text: description });
            }
            return (React.createElement("div", { className: groupClassName },
                React.createElement("label", null, this.props.label),
                React.createElement("input", { name: this.props.name, type: this.props.type, value: this.props.value, className: "form-control", placeholder: this.props.placeholder, onChange: this.handleChange }),
                React.createElement("span", { className: spanClassNameValue }),
                errorMessageElement,
                descriptionElement));
        };
        return InputText;
    }(React.Component));
    InputForm_1.InputText = InputText;
    /*
    * 汎用的なボタンコンポーネント
    *  name: buttonタグのname属性の値
    *  text: buttonタグのtextの値
    *  call: イベント通知用のコールバック関数
    *  size: buttonタグの横幅調整用
    *    ボタンが複数ある場合はサイズを調整する
    */
    var Button = (function (_super) {
        __extends(Button, _super);
        function Button() {
            var _this = _super.call(this) || this;
            _this.handleClick = _this.handleClick.bind(_this);
            return _this;
        }
        Button.prototype.handleClick = function (event) {
            if (this.props.call) {
                this.props.call(event.target.name);
            }
        };
        Button.prototype.render = function () {
            var divClassNameValue = 'col-xs-' + this.props.size;
            if (this.props.text === '') {
                return (React.createElement("div", { className: divClassNameValue }));
            }
            else {
                return (React.createElement("div", { className: divClassNameValue },
                    React.createElement("button", { name: this.props.name, type: "button", className: "btn btn-primary btn-block btn-flat", onClick: this.handleClick }, this.props.text)));
            }
        };
        return Button;
    }(React.Component));
    InputForm_1.Button = Button;
    /**
     * 入力フォームコンポーネント（抽象クラス）
     * 継承した上で、フォームの構成に必要なデータをdataメンバに定義する。
     */
    var InputForm = (function (_super) {
        __extends(InputForm, _super);
        function InputForm() {
            return _super.apply(this, arguments) || this;
        }
        InputForm.prototype.render = function () {
            var _this = this;
            var message = null;
            if (this.data.message) {
                message = React.createElement("p", { className: "login-box-msg" }, this.data.message);
            }
            var inputTexts = this.data.inputTexts.map(function (inputText, index) {
                var inputTextProps = Object.assign({}, inputText, _this.state.inputTexts[inputText.name]);
                return React.createElement(InputText, __assign({ key: 'index' + index }, inputTextProps));
            });
            var buttons = this.data.buttons.map(function (button, index) {
                return React.createElement(Button, __assign({ key: 'index' + index }, button));
            });
            var errorMessage = null;
            if (this.state.errorMessage) {
                errorMessage = React.createElement(ErrorMessage, { text: this.state.errorMessage.text });
            }
            var description = null;
            if (this.data.description) {
                description = React.createElement(Description, { text: this.data.description });
            }
            var links = [];
            if (this.data.links) {
                links = this.data.links.map(function (link, index) {
                    return React.createElement("p", null,
                        React.createElement("a", __assign({}, link), link.linkText));
                });
            }
            var processing = null;
            if (this.state.processing) {
                processing = React.createElement("div", { className: "overlay" },
                    React.createElement("i", { className: "fa fa-refresh fa-spin" }));
            }
            return (React.createElement("div", { className: "box input-form-box login-box" },
                React.createElement(InputForm_1.EkispertLogo, null),
                React.createElement("div", { className: "login-box-body" },
                    message,
                    React.createElement("form", null,
                        errorMessage,
                        inputTexts,
                        description,
                        React.createElement("div", { className: "row" }, buttons)),
                    links),
                processing));
        };
        /**
         * Stateを更新する
         * 更新する値の階層が深いので、setStateのコールバックを使い全体の値を更新する
         */
        InputForm.prototype.setValue = function (name, value) {
            this.setState(function (state) {
                state.inputTexts[name].value = value;
                return state;
            });
        };
        /**
         * Stateをバリデートする
         * setStateのコールバックを使い最新の値を取得して検証する
         */
        InputForm.prototype.validate = function (name, params) {
            var _this = this;
            this.setState(function (state) {
                var errorMessage = null;
                params.forEach(function (param) {
                    var validateType = null;
                    var validateParam = null;
                    if (errorMessage == null) {
                        if (Array.isArray(param)) {
                            validateType = param[0];
                            validateParam = param[1];
                        }
                        else {
                            validateType = param;
                        }
                        switch (validateType) {
                            case VALIDATE_TYPE.EXIST:
                                errorMessage = _this.checkStateValueExist(state, name);
                                break;
                            case VALIDATE_TYPE.SAME:
                                if (validateParam) {
                                    errorMessage = _this.checkStateValueSame(state, name, validateParam);
                                }
                                break;
                            default:
                        }
                    }
                });
                Object.assign(state.inputTexts[name], {
                    errorMessage: errorMessage,
                });
                var clear = true;
                if (state.errorMessage && state.errorMessage.type !== ERROR_MESSAGE_TYPE.VALIDATE) {
                    clear = false;
                }
                else {
                    for (var key in state.inputTexts) {
                        if (state.inputTexts[key].errorMessage) {
                            clear = false;
                        }
                    }
                }
                if (clear) {
                    state.errorMessage = null;
                }
                return state;
            });
        };
        /**
         * 値の有無を確認する。
         */
        InputForm.prototype.checkStateValueExist = function (state, name) {
            var value = state.inputTexts[name].value;
            if (value === '') {
                var label = state.inputTexts[name].label;
                var errorMessage = 'エラー： ' + label + 'を入力してください。';
                return { text: errorMessage, type: ERROR_MESSAGE_TYPE.VALIDATE };
            }
            return null;
        };
        /**
         * 値が同じか確認する
         */
        InputForm.prototype.checkStateValueSame = function (state, name, sameStateName) {
            var value = state.inputTexts[name].value;
            var sameValue = state.inputTexts[sameStateName].value;
            if (value !== sameValue) {
                var label = state.inputTexts[name].label;
                ;
                var sameStatelabel = state.inputTexts[sameStateName].label;
                ;
                var errorMessage = 'エラー： ' + label + 'には' + sameStatelabel + 'と同じ文字列を入力してください。';
                return { text: errorMessage, type: ERROR_MESSAGE_TYPE.VALIDATE };
            }
            return null;
        };
        return InputForm;
    }(React.Component));
    InputForm_1.InputForm = InputForm;
})(InputForm || (InputForm = {}));
;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = InputForm;



//////////////////
// WEBPACK FOOTER
// ./build/js/components/input-form.js
// module id = 749
// module chunks = 1 2 3 4 5 6 8